import { resendInvite, OPEN_RESEND_INVITE_MODAL, CLOSE_RESEND_INVITE_MODAL } from './types';

export function requestResendInvite(teamMemberId) {
  return {
    type: resendInvite.request,
    teamMemberId,
  };
}

export function requestResendInviteSuccess() {
  return {
    type: resendInvite.success,
  };
}

export function requestResendInviteFailure(error = true) {
  return {
    type: resendInvite.failure,
    error,
  };
}

export function openResendInviteModal(teamMember) {
  return {
    type: OPEN_RESEND_INVITE_MODAL,
    teamMember,
  };
}

export function closeResendInviteModal() {
  return {
    type: CLOSE_RESEND_INVITE_MODAL,
  };
}
